// extracted by mini-css-extract-plugin
export default {"sideBar":"SideBarWhatWeDo_sideBar__umckB"};